import React from 'react'

export const MessageAreaSkeleton: React.FC = () => (
  <div className="flex flex-col flex-1 h-full bg-white dark:bg-background overflow-hidden">
    <div className="h-16 min-h-16 px-6 border-b border-gray-200 dark:border-border flex items-center bg-white dark:bg-background flex-shrink-0">
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 bg-gray-200 dark:bg-muted rounded-full animate-pulse flex-shrink-0"></div>
        <div className="flex flex-col gap-1">
          <div className="w-32 h-4 bg-gray-200 dark:bg-muted rounded animate-pulse"></div>
          <div className="w-24 h-3 bg-gray-100 dark:bg-muted/60 rounded animate-pulse"></div>
        </div>
      </div>
    </div>
    <div className="flex-1 overflow-y-auto overflow-x-hidden relative px-6">
      <div className="flex flex-col-reverse min-h-full">
        {Array.from({ length: 5 }, (_, index) => {
          const isOutgoing = index % 3 === 0
          return (
            <div
              key={index}
              className={`mb-4 flex items-start gap-2 ${isOutgoing ? 'flex-row-reverse' : 'flex-row'}`}
            >
              <div className="w-8 h-8 bg-gray-200 dark:bg-muted rounded-full animate-pulse flex-shrink-0"></div>
              <div
                className={`max-w-[70%] flex flex-col gap-1 ${isOutgoing ? 'items-end' : 'items-start'}`}
              >
                {!isOutgoing && (
                  <div className="w-20 h-3 bg-gray-200 dark:bg-muted rounded animate-pulse mb-0.5"></div>
                )}
                <div
                  className={`bg-gray-100 dark:bg-muted rounded-2xl px-4 py-3 animate-pulse ${
                    index % 4 === 0
                      ? 'w-72'
                      : index % 4 === 1
                        ? 'w-52'
                        : index % 4 === 2
                          ? 'w-40'
                          : 'w-64'
                  } h-10`}
                ></div>
                <div className="w-12 h-2 bg-gray-100 dark:bg-muted/60 rounded animate-pulse"></div>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  </div>
)
